export default __webpack_public_path__ + "locales/tr/FillPDFDialog.json?hash=642cb8ea55fe8da37bdfdcd25faf45ac";